export default __webpack_public_path__ + "static/media/onevanilla.acc9848b.svg";